$(document).ready(function(){
  theme_custom.slickSlider();
  theme_custom.clickChangeEvent();
});

theme_custom.slickSlider = function(){

  /* Yaprak Site Slides Customizations START */
  $('.yaprak-site-slides').slick({
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    arrows: false
  });
  /* Yaprak Site Slides Customizations END */

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    infinite: true,
    asNavFor: '.slider-for',
    slidesToShow: 4 ,
    autoplay: false,
    centerMode: true,
    centerPadding: '0px',
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 4
        }
      },
      {
        breakpoint: 750,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      }
    ]
  });

  /*

  It activates the MULTIPLE IMAGE SLIDER SLIDING ACTION.
  DISABLED, BECAUSE THE SLIDER HAS TO BE GRID DESIGN


  $(".multiple_image_sliders").slick({
    slidesToShow: 5,
    infinite:false,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 2.3
        }
      }
    ]
  });*/

  $('media-gallery .slider-content').on('init beforeChange', function(event, slick, currentSlide, nextSlide){
    if(!window.perfImage) return;
    var idx = (typeof nextSlide === 'number') ? nextSlide : (slick.currentSlide || 0);
    $(slick.$slides[idx]).find('img.perf-defer').each(function(){ perfImage.hydrate(this); });
    // komşu slaytları da hazırla (klonlar dahil aynı index değerini taşır)
    [idx - 1, idx + 1].forEach(function(i){ var s = slick.$slides[(i + slick.slideCount) % slick.slideCount]; if(s){ $(s).find('img.perf-defer').each(function(){ perfImage.hydrate(this); }); } });
  });
  $('media-gallery .slider-content').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    asNavFor: 'media-gallery .slider-thumb',
    responsive: [
      {
        breakpoint: 749,
        settings: {
          arrows: false,
        }
      }
    ]
  });
  $('media-gallery .slider-thumb').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    vertical:true,
    infinite: false,
    asNavFor: 'media-gallery .slider-content',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 5,
          vertical:false,
          verticalSwiping:false,
          arrows: true
        }
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 4,
          vertical:false,
          verticalSwiping:false,
          arrows: true
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 3,
          vertical:false,
          verticalSwiping:false,
          arrows: true
        }
      }
    ]
  });


  if($('.custom_vertical_slider').length > 0){
    $('.custom_vertical_slider ul').slick({
      vertical:true,
      verticalSwiping:true,
      slidesToShow: 5,
      slidesToScroll: 1,
      touchMove:true,
      swipeToSlide:true,
      swipe:true,
      focusOnSelect: true,
    });

    $('.custom_vertical_slider ul').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var dataImageId = $(`.custom_vertical_slider ul li[data-slick-index="${nextSlide}"]`).attr('data-image-id');
      $(`slider-component ul li`).removeClass('is-active');
      $(`slider-component ul li[data-media-id$="${dataImageId}"]`).addClass('is-active');
    });

    var mediaId = $(`slider-component ul li.is-active`).attr('media--id');
    var dataMediaPosition = $(`.custom_vertical_slider ul li[data-image-id="${mediaId}"]`).attr('data-media-position');
    $('.custom_vertical_slider ul').slick('slickGoTo', dataMediaPosition-1, true);

    let startX;
    $(document).on('dragstart', 'slider-component li', function(e) {
      startX = e.originalEvent.clientX;
    });
    $(document).on('dragend', 'slider-component li', function(e) {
      let endX = e.originalEvent.clientX;
      let direction = endX > startX ? 'right' : 'left';
      if(direction == 'left'){
        $('.custom_vertical_slider .slick-prev.slick-arrow').click();
      }else if(direction == 'right'){
        $('.custom_vertical_slider .slick-next.slick-arrow').click();
      }
    });
  }
}

/*
  Çoklu video slider (anasayfa + ürün sayfası metafield):
  Videolar perf-video.js ile tembel yüklenir. Yalnızca aktif slayt "data-autoplay" alır;
  görünür alandaysa hemen oynar, değilse alana girince perf-video.js oynatır.
*/
theme_custom.playVideo = function(video){
  if(!video) return;
  video.setAttribute('data-autoplay', '');
  if(window.perfVideo && video.getAttribute('data-perf-inview')){
    perfVideo.play(video);
  }
};
theme_custom.pauseVideo = function(video){
  if(!video) return;
  video.removeAttribute('data-autoplay');
  if(!video.paused){ video.pause(); }
};
theme_custom.syncSliderVideo = function(){
  var $for = $('.image_slider_main.image_with_slider.slider-for');
  $for.find('video').each(function(){ theme_custom.pauseVideo(this); });
  theme_custom.playVideo($for.find('.slick-current.slick-active video')[0]);
};
$('.image_slider_main_wrap .image_slider_main.image_with_slider_thumb.slider-nav').on('afterChange', theme_custom.syncSliderVideo);
$('.image_slider_main_wrap .image_slider_main.image_with_slider.slider-for').on('init afterChange', function(){
  setTimeout(theme_custom.syncSliderVideo, 0);
});

theme_custom.clickChangeEvent = function(){
  $(document).on('click', '.multi_video_slider_main .slider-for .image_item_main.slick-active .image_url', function(){
    const video = $(this).find('video')[0];
    if(video){
      if (video.paused) {
        theme_custom.playVideo(video);
        if(window.perfVideo){ perfVideo.play(video); }
        $(this).parents('.image_item_main').find('.video-play-icon').removeClass('active');
      } else {
        theme_custom.pauseVideo(video);
        $(this).parents('.image_item_main').find('.video-play-icon').addClass('active');
      }
    }
  });

  $(document).on('click', '.multi_video_slider_main .slider-for .image_item_main.slick-active .video-play-icon', function(){
    const video = $(this).parents('.image_item_main').find('video')[0];
    if(video){
      if (!video.paused) {
        theme_custom.pauseVideo(video);
      } else {
        theme_custom.playVideo(video);
        if(window.perfVideo){ perfVideo.play(video); }
        $(this).removeClass('active');
      }
    }
  });
}


/* AUTOMATED TEXT CHANGER START */
//This code targets the text from main-product section

let texts = Array.from(document.querySelectorAll('.product__text .metafield-rich_text_field li'));
if (texts.length > 1) {
  let i = 1; // Starting from 1 because 0 already has is-visible, it would cause slight delay otherwise.

  // Check if any element already has the 'is-visible' class
  if (!texts.some(text => text.classList.contains('is-visible'))) {
    texts[0].classList.add('is-visible');
  }

  setInterval(() => {
    texts.forEach(text => {
      text.classList.remove('is-visible');
    });
    texts[i].classList.add('is-visible');
    i += 1;
    if (i >= texts.length) {
      i = 0;
    }
  }, 5000);
}

/* AUTOMATED TEXT CHANGER END */
